export function computeServiceFilters(items) {
  if (!items || items.length === 0) {
    return {
      cuisine: [],
      pickupAvailable: false,
      deliveryAvailable: false,
      priceRange: null,
      homeServiceAvailable: false,
      consultationRequired: false,
      depositRequired: false
    };
  }

  const cuisine = [...new Set(items.flatMap(item => item.cuisineCountry || []))];
  const pickupAvailable = items.some(item => item.pickupAvailable === true);
  const deliveryAvailable = items.some(item => item.deliveryAvailable === true);
  const homeServiceAvailable = items.some(item => item.homeServiceAvailable === true);
  const consultationRequired = items.some(item => item.consultationRequired === true);
  const depositRequired = items.some(item => item.depositRequired === true);

  const prices = items.flatMap(item => {
    const vals = [];
    if (item.price != null) vals.push(item.price);
    if (item.minPrice != null) vals.push(item.minPrice);
    if (item.maxPrice != null) vals.push(item.maxPrice);
    return vals;
  }).filter(p => typeof p === 'number' && !isNaN(p));

  const priceRange = prices.length > 0 
    ? { min: Math.min(...prices), max: Math.max(...prices) }
    : null;

  return {
    cuisine,
    pickupAvailable,
    deliveryAvailable,
    priceRange,
    homeServiceAvailable,
    consultationRequired,
    depositRequired
  };
}
